
import { QUEUE_SOCKET } from '../../actions/queueAction';

const initState = {
    queues_screening: "",
    queues_physical: "",
    queues_collection: "",
    queues_mas: "",
}

export const queueReducer = (state = initState, action) => {
    switch (action.type) {
        case QUEUE_SOCKET.MSA_EXIT_ROOM:
            return {
                ...state,
                queues_mas: action.payload,
            }
        default:
            return state;
    }
}

const initStateConnect = {
    isConnect: true
}
export const socketConnectReducer = (state = initStateConnect, action) => {
    switch (action.type) {
        case QUEUE_SOCKET.SOCKET_CONNECT_NEW:
            return {
                ...state,
                isConnect: action.payload,
            }
        default:
            return state;
    }
}
